// extracted by mini-css-extract-plugin
export default {"rightPanelWidth":"337px","sidebarWidth":"250px"};